import React, { useState } from "react";
import { searchCanonicalLogs } from "../api/canonicalService";
import JsonViewerModal from "./JsonViewerModal";

const PAGE_SIZE = 50;

const ENTITY_TYPES = ["", "BOM", "ARTICLE", "SUPPLIER"];

export default function CanonicalLogPage() {
  const [filters, setFilters] = useState({
    entityType: "", entityId: "", correlationId: "", status: "",
    dateFrom: "", dateTo: "",
  });
  const [page, setPage] = useState(0);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const onChange = (e) => setFilters({ ...filters, [e.target.name]: e.target.value });

  const doSearch = async (targetPage = 0) => {
    setLoading(true);
    setError(null);
    try {
      const params = { size: PAGE_SIZE, page: targetPage };
      Object.entries(filters).forEach(([k, v]) => {
        if (v !== "" && v != null) params[k] = v;
      });
      const data = await searchCanonicalLogs(params);
      setResult(data);
      setPage(targetPage);
    } catch {
      setError("Search failed. Your session may have expired — try logging out and back in.");
    } finally {
      setLoading(false);
    }
  };

  const clear = () => {
    setFilters({ entityType: "", entityId: "", correlationId: "", status: "", dateFrom: "", dateTo: "" });
    setResult(null);
    setPage(0);
    setError(null);
  };

  const startRow = page * PAGE_SIZE + 1;
  const endRow = result ? page * PAGE_SIZE + result.rows.length : 0;

  return (
    <div>
      <div className="card">
        <h2>Canonical Log Search</h2>
        <div className="payload-filters">
          <select name="entityType" value={filters.entityType} onChange={onChange}>
            {ENTITY_TYPES.map((t) => (
              <option key={t} value={t}>{t || "All Types"}</option>
            ))}
          </select>
          <input
            name="entityId"
            placeholder="Entity ID (material / supplier #)"
            value={filters.entityId}
            onChange={onChange}
          />
          <input
            name="correlationId"
            placeholder="Correlation ID"
            value={filters.correlationId}
            onChange={onChange}
          />
          <input
            name="status"
            placeholder="Status"
            value={filters.status}
            onChange={onChange}
          />
          <label className="date-label">
            From
            <input name="dateFrom" type="date" value={filters.dateFrom} onChange={onChange} />
          </label>
          <label className="date-label">
            To
            <input name="dateTo" type="date" value={filters.dateTo} onChange={onChange} />
          </label>
          <button className="btn-primary" onClick={() => doSearch(0)} disabled={loading}>
            {loading ? "Searching…" : "Search"}
          </button>
          <button className="btn-secondary" onClick={clear} disabled={loading}>
            Clear
          </button>
        </div>
      </div>

      {error && <div className="payload-error">{error}</div>}

      {result && (
        <div className="card">
          <div className="payload-result-info">
            {result.rows.length === 0
              ? "No results found."
              : `Showing ${startRow}–${endRow}${result.hasMore ? "+" : ""}`}
          </div>
          <table className="log-table">
            <thead>
              <tr>
                <th>Type</th>
                <th>Entity ID</th>
                <th>Correlation ID</th>
                <th>Status</th>
                <th>Created At</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {result.rows.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.entityType}</td>
                  <td>{row.entityId}</td>
                  <td>{row.correlationId}</td>
                  <td>{row.status}</td>
                  <td>{row.createdAt ? new Date(row.createdAt).toLocaleString() : ""}</td>
                  <td>
                    <button className="btn-inspect" onClick={() => setSelectedRow(row)}>
                      Inspect
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="payload-pagination">
            <button onClick={() => doSearch(page - 1)} disabled={page === 0 || loading}>
              &larr; Prev
            </button>
            <span>Page {page + 1}</span>
            <button onClick={() => doSearch(page + 1)} disabled={!result.hasMore || loading}>
              Next &rarr;
            </button>
          </div>
        </div>
      )}

      {selectedRow && (
        <JsonViewerModal row={selectedRow} onClose={() => setSelectedRow(null)} />
      )}
    </div>
  );
}
